



















import { BaseMixin } from '@/mixins/BaseMixin';
import { FormatMixin } from '@/mixins/FormatMixin';
import 'dayjs/locale/de';
import { mixins } from 'vue-class-component';
import Multiselect from 'vue-multiselect';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'declined-reason-select',
  components: { Multiselect },
})
export default class DeclinedReasonSelect extends mixins(BaseMixin, FormatMixin) {
  @Prop({ type: String, required: true })
  value!: string[];

  @Prop({ type: Boolean, default: () => false })
  multiple!: boolean;

  get options() {
    return [
      'Preis',
      'Kein Bedarf/Interesse',
      'Zu komplex',
      'Nicht erreicht',
      'Nicht dringend',
      'Sonstiges',
    ];
  }

  get placeholder() {
    return 'Absagegrund wählen';
  }

  updateReasonSelection(reason: string) {
    this.$emit('update-reason', reason);
  }
  label(reason: string) {
    return `${reason}`;
  }
}
